import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux'

// const calculatePercentage = (loaded, total) => (Math.floor(loaded * 1.0) / total);
class AxiosLoadingBar extends React.Component {
    constructor(){
        super();
        this.state = {
            requestIndex: -1,
            progress: {}
        }
    }

    setupStartProgress = () => {
        axios.interceptors.request.use(config => {
            let { progress, requestIndex } = this.state;
            requestIndex++;
            progress = { ...progress, [requestIndex]: 0 };
            this.setState({ requestIndex, progress });
            return config;
        });
    }

    setupStopProgress = () => {
        const updateState = () => {
            let { requestIndex, progress } = this.state;
            delete progress[requestIndex];
            requestIndex--;
            this.setState({ requestIndex, progress });
        }
        const responseFunc = response => {
            updateState();
            return response;
        }

        const errorFunc = error => {
            updateState();
            return Promise.reject(error)
        }
        axios.interceptors.response.use(responseFunc, errorFunc)
    }

    componentDidMount() {
        this.setupStartProgress();
        // this.setupUpdateProgress();
        this.setupStopProgress();
    }
    
    render() {
        const { isNewSmUi, isLoaderActive } = this.props;
        let barStyle;
        if (isLoaderActive) 
            barStyle = {
                visibility: 'visible'
            }
        else
            barStyle = {};

        if(isNewSmUi){
                barStyle['top'] = '0px';
                barStyle['left'] = '0px';
                barStyle['zIndex'] = '1';
            }   
        return (
            <div className="h-progbar" style={barStyle}>
                <div className="indeterminate" />
            </div>
        )
    }
}

const mapStateToProps = ({ appModes: { hiddenLoadingbar }, loader: {active}}) => ({
    hiddenLoadingbar,
    isLoaderActive: active
})
AxiosLoadingBar = connect(mapStateToProps)(AxiosLoadingBar);

export default AxiosLoadingBar;
export {
    AxiosLoadingBar
}